var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.readonly || _vm.allReadonly)?_c('StaticField',{attrs:{"value":_vm.text}}):_c('VSelect',{attrs:{"value":_vm.values,"items":_vm.options,"rules":_vm.checker,"outlined":"","multiple":"","dense":"","hideDetails":"auto"},on:{"change":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }